import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectProps {
  id: string;
  label: string;
  value: string;
  required?: boolean;
  hint?: string;
  options: {
    value: string;
    label: string;
  }[];
  onChange: (value: string) => void;
}
export function Select({
  id,
  label,
  value,
  required,
  hint,
  options,
  onChange
}: SelectProps) {
  return <div data-id="element-87" data-mp="1qhrff2mrva07">
      <label htmlFor={id} className="block text-[12px] font-semibold text-ink-700" data-id="element-88" data-mp="1qhhkr1qs8eo6">
        {required && <span className="mr-0.5 text-danger-fg" aria-hidden="true" data-id="element-89" data-mp="1cm5p8s4syk67">
            *
          </span>}
        {label}
      </label>
      <div className="relative mt-1" data-id="element-90" data-mp="12metkn4i9z4j">
        <select id={id} value={value} onChange={event => onChange(event.target.value)} aria-describedby={hint ? `${id}-hint` : undefined} className="h-9 w-full appearance-none rounded border border-line-strong bg-white pl-2.5 pr-8 text-[13px] text-ink-900 transition-colors duration-150 ease-out hover:border-ink-400 focus:border-leaf-600" data-id="element-91" data-mp="12ngbnbjxvlvr">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-92" data-mp="10vodu5vqylf5">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-500" aria-hidden="true" data-id="element-93" data-mp="1fjj6jm9r8ps8" />
      </div>
      {hint && <p id={`${id}-hint`} className="mt-1 text-[11px] leading-snug text-ink-500" data-id="element-94" data-mp="mvx3cf4fvn5w">
          {hint}
        </p>}
    </div>;
}